import React from "react";
import Spinner from "../../../../Spinner";

// eslint-disable-next-line import/prefer-default-export
import { jsx as _jsx } from "react/jsx-runtime";
export function LoadingState() {
  return /*#__PURE__*/_jsx(Spinner, {
    size: "sm"
  });
}